import { createContext } from "react";

export const CurrencyContext = createContext(null); // ✅ No default value here
